import React from 'react';
import { Checkbox, Button, Icon, Popover } from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

class ColumnSelection extends React.Component {
  state = {
    open: false
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const list = [...this.props.columnList];
    const [removed] = list.splice(result.source.index, 1);
    list.splice(result.destination.index, 0, removed);

    this.props.columnReorder(list);
  };

  checkChange = list => {
    this.props.activeReorder(list);
  };

  toggleClick = open => {
    this.setState({ open });
  };

  popoverContent() {
    const { columnList, activeColumns } = this.props;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div className="container__columns" ref={provided.innerRef}>
              {columnList.map((col, index) => (
                <Draggable key={col} draggableId={col} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Checkbox.Group
                        onChange={this.checkChange}
                        options={[col]}
                        value={activeColumns}
                        className="checkbox__columns"
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }

  render() {
    const { open } = this.state;

    return (
      <div className="item__listings--right column__selection">
        <Popover
          content={this.popoverContent()}
          trigger="click"
          visible={open}
          onVisibleChange={this.toggleClick}
          placement="bottom"
        >
          <Button style={{ marginLeft: 8 }}>
            Select Fields <Icon type="down" />
          </Button>
        </Popover>
      </div>
    );
  }
}

export default ColumnSelection;
